<script setup lang="ts">
import { useTemplateRef, onMounted, onUnmounted } from "vue";
import { useFilesStore } from "@/stores/files";
const fileInput = useTemplateRef("fileInputRef");
const fileStore = useFilesStore();

const addFile = (file: File) => {
    if (file.size === 0) {
        alert("File is empty");
        return;
    }

    console.log("Adding file", file);
    fileStore.addFile(file);
};
const onFileSelected = (event: Event) => {
    if (!(event.target instanceof HTMLInputElement)) return;
    if (!event.target.files) return;
    for (const file of event.target.files) addFile(file);
    event.target.value = "";
};
const onDrop = (event: DragEvent) => {
    event.preventDefault();
    if (!event.dataTransfer) return;
    if (!event.dataTransfer.files) return;
    for (const file of event.dataTransfer.files) addFile(file);
};

const onDragOver = (event: DragEvent) => {
    event.preventDefault();
};
const onDragEnter = (event: DragEvent) => {
    event.preventDefault();
};
const body = document.body;
onMounted(() => {
    body.addEventListener("dragover", onDragOver);
    body.addEventListener("dragenter", onDragEnter);
    body.addEventListener("drop", onDrop);
});

onUnmounted(() => {
    body.removeEventListener("dragover", onDragOver);
    body.removeEventListener("dragenter", onDragEnter);
    body.removeEventListener("drop", onDrop);
    console.log("DropButton unmounted");
});
</script>

<template>
    <span class="drop-button" @click="fileInput?.click">
        <u>HERE</u>
        <input ref="fileInputRef" type="file" @change="onFileSelected" multiple />
    </span>
</template>

<style scoped lang="scss">
input[type="file"] {
    display: none;
}
.drop-button {
    cursor: pointer;
    display: flex;
    flex-direction: column;
    justify-content: center;
    place-items: center;
}
</style>
